import React, { FC } from 'react';
import { TextInput, useFormContext } from 'framework/form';
import { EDITABLE_LIST_FIELD } from 'framework/list';
import OriginalPlannedDateInput from 'domain/projects/newProject/milestones/OriginalPlannedDateInput';
import { compactDisabledInputSx } from 'domain/projects/newProject/shared/compactDisabledInputSx';
import PredecessorSection from './PredecessorSection';

const getTableCells = async (isEditMode: boolean) => [
  {
    type: EDITABLE_LIST_FIELD,
    source: 'alias',
    isEditor: true,
    component: TextInput,
    componentProps: { label: '', disabled: true },
    gridCellProps: { size: 0.5, sx: compactDisabledInputSx },
  },
  {
    type: EDITABLE_LIST_FIELD,
    source: 'title',
    isEditor: true,
    component: TextInput,
    componentProps: { label: 'Milestone', disabled: !isEditMode },
    gridCellProps: { size: 7 },
  },
  {
    type: EDITABLE_LIST_FIELD,
    source: 'initialPlannedDate',
    isEditor: true,
    component: OriginalPlannedDateInput,
    componentProps: { label: 'Original planned date', disabled: !isEditMode },
    gridCellProps: { size: 4 },
  },
];

const PredecessorMilestones: FC = () => {
  const { data } = useFormContext();
  const milestones = data?.milestones ?? [];

  return (
    <PredecessorSection
      title="Milestones"
      listSource="milestones"
      isEmpty={milestones.length === 0}
      getTableCells={getTableCells}
    />
  );
};

export default PredecessorMilestones;
